/**
 * Textos visibles de botones que el sector pidió renombrar. [NUEVO 20/10/2026]
 *
 * Solo cambian el TEXTO del botón: la acción, la ruta de la API, el estado al
 * que pasa la factura y el evento de auditoría ("Autorizado por Contaduría")
 * siguen siendo exactamente los mismos. Para volver al texto anterior alcanza
 * con cambiar el valor acá.
 *
 * Aplica SOLO al Paso 1 (bandeja "Para autorizar", exclusiva de Contaduría):
 * en el Paso 1 autorizar es mandarle la factura al Aprobador. El botón del
 * Aprobador (Paso 2) sigue diciendo "Autorizar" a propósito — ahí es la
 * autorización final, la que manda la factura a SAP.
 */
export const ETIQUETA_AUTORIZAR_CONTADURIA = "Enviar";
export const ETIQUETA_AUTORIZAR_CONTADURIA_LOTE = "Enviar seleccionadas";
